import BProfileDiaryGlucoseReportDay from "./BProfileDiaryGlucoseReportDay";

export default class BProfileDiaryGlucoseReport
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.b-profile-diary-glucose-report`;

	static initialize()
	{
		this.addEventListeners();

		document.querySelectorAll(this.selector()).forEach(el => {
			(new this(el)).refresh();
		});
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			if (event.target.matches(`${this.selector()}__select-critical-button`)) {
				let report = new this(event.target.closest(this.selector()));
				report.checkCriticalDays();
			}
		});

		document.addEventListener("change", event => {
			if (event.target.matches(BProfileDiaryGlucoseReportDay.checkboxSelector())) {
				let report = new this(event.target.closest(this.selector()));
				report.refresh();
			}
		});

		document.addEventListener("click", event => {
			if (event.target.matches(`${this.selector()}__select-all-button`)) {
				let report = new this(event.target.closest(this.selector()));
				report.checkAllDays();
			}
		});
	}

	getDays()
	{
		let res = [];
		this.el.querySelectorAll(BProfileDiaryGlucoseReportDay.selector()).forEach(el => {
			res.push(new BProfileDiaryGlucoseReportDay(el));
		});

		return res;
	}

	getCriticalDays()
	{
		let res = [];
		this.getDays().forEach(day => {
			if (day.isCritical()) {
				res.push(day);
			}
		});

		return res;
	}

	getCheckedDays()
	{
		let res = [];
		this.getDays().forEach(day => {
			if (day.isChecked()) {
				res.push(day);
			}
		});

		return res;
	}

	getCheckCriticalDaysButtons()
	{
		return this.el.querySelectorAll(`.b-profile-diary-glucose-report__select-critical-button`);
	}

	getSubmitButtons()
	{
		return this.el.querySelectorAll(`.b-profile-diary-glucose-report__submit-button`);
	}

	uncheckAllDays()
	{
		this.getDays().forEach(day => {
			day.uncheck();
		});

		this.refresh();
	}

	checkAllDays()
	{
		this.uncheckAllDays();
		this.getDays().forEach(day => {
			day.check();
		});

		this.refresh();
	}

	checkCriticalDays()
	{
		this.uncheckAllDays();
		this.getCriticalDays().forEach(day => {
			day.check();
		});

		this.refresh();
	}

	refresh()
	{
		this.getSubmitButtons().forEach(el => {
			el.hidden = !this.getCheckedDays().length;
		})
		this.getCheckCriticalDaysButtons().forEach(el => {
			el.hidden = !this.getCriticalDays().length;
		});
	}
}
